import { Link } from 'react-router-dom';
import styles from '../styles/Navbar.module.css';
import { LogOut } from 'lucide-react';
import T from './T';
import LanguageSwitcher from './LanguageSwitcher';

const HeadsetIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="#0d1b3e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 18v-6a9 9 0 1 1 18 0v6" />
    <path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3z" />
    <path d="M3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z" />
  </svg>
);

function getInitials(name) {
  return name
    ? name
        .split(' ')
        .map((n) => n[0])
        .join('')
        .toUpperCase()
        .slice(0, 2)
    : '';
}

export default function Navbar({ userName = 'Tunde Usman', onLogout }) {
  return (
    <nav className={styles.navbar}>
      <Link to="/staff" className={styles.brand}>
        <div className={styles.logoIcon}>
          <HeadsetIcon />
        </div>
        <span className={styles.title}><T>Autochek Tech Support</T></span>
      </Link>

      <div className={styles.right}>
        <LanguageSwitcher variant="dark" />
        <div className={styles.userInfo}>
          <span className={styles.userName}>{userName}</span>
          <div className={styles.avatar}>{getInitials(userName)}</div>
        </div>
        
        {onLogout && (
          <button onClick={onLogout} className={styles.logoutBtn} title="Logout">
            <LogOut size={18} />
            <span className={styles.logoutText}><T>Logout</T></span>
          </button>
        )}
      </div>
    </nav>
  );
}
